module.exports = __webpack_public_path__ + "img/7-7.12fb1587.png";